<!-- 买卡流程 -->

<template>
  <div>
    <div class="yellow-view">
      <div>
        1、帐号请绑定手机号码，或者填写正确的联系方式，以便我们处理您提交的卡出现问题时可以及时和您联系；
      </div>
      <div style="margin-top: 10px">
        2、请务必按照格式提交正确的卡号卡密，以免浪费您的时间并给您造成不必要的困扰；
      </div>
    </div>
    <div class="right-item-content" style="align-items: center; justify-content: center; box-sizing: content-box;justify-content: space-evenly; ">
      <!-- <procedure></procedure> -->
      <div  class="view-page">
        <div class="item-view">
            <img src="@/assets/newImage/编组 50@2x.png" alt="">
            <div style="margin-top: 10px; font-size: 10px;">1、注册账号</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4); flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; " class="text-one-line" >手机号码注册账号</div>
        </div>
        <img src="@/assets/newImage/2e96a0ffe3e8066bf65e0b6fc1e39be3@2x.png" class="fenge" alt="" >
   

        <div class="item-view">
            <img src="@/assets/newImage/步骤3.png" alt="">
            <div style="margin-top: 10px;font-size: 10px">2、实名认证</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4);flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "  class="text-one-line">完成实名认证和签署</div>
        </div>
     
        <img src="@/assets/newImage/2e96a0ffe3e8066bf65e0b6fc1e39be3@2x.png" class="fenge" alt="" >
        <div class="item-view">
            <img src="@/assets/newImage/步骤2.png" alt="">
            <div style="margin-top: 10px;font-size: 10px">3、提交卡密</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4);flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "   class="text-one-line">提交卖卡卡券信息</div>
        </div>
        <img src="@/assets/newImage/2e96a0ffe3e8066bf65e0b6fc1e39be3@2x.png" class="fenge" alt="" >
        <div class="item-view">
            <img src="@/assets/newImage/步骤3.png" alt="">
            <div style="margin-top: 10px;font-size: 10px">4、验卡成功</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4);flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; "   class="text-one-line">验卡回收成功资金到账</div>
        </div>
     
        <img src="@/assets/newImage/2e96a0ffe3e8066bf65e0b6fc1e39be3@2x.png" class="fenge" alt="" >
        <div class="item-view">
            <img src="@/assets/newImage/步骤4.png" alt="">
            <div style="margin-top: 10px;font-size: 10px">5、账户提现</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4);flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; " class="text-one-line" >支持银行卡支付宝提现</div>
        </div>
        <img src="@/assets/newImage/2e96a0ffe3e8066bf65e0b6fc1e39be3@2x.png" class="fenge" alt="" >
        <div class="item-view">
            <img src="@/assets/newImage/步骤5.png" >
            <div style="margin-top: 10px;font-size: 10px">6、交易成功</div>
            <div style="margin-top: 10px;font-size: 8px;color: rgba(0,0,0,0.4);flex-shrink: 0;white-space: nowrap;overflow: hidden;text-overflow: ellipsis; " class="text-one-line" >提现成功交易完成</div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import procedure from "@/components/base/procedure.vue";
export default {
  components: {
    procedure
  },
};
</script>

<style lang="scss" scoped>
.right-item-content {
  margin-top: 10px;
  padding: 20px;
  color: #000000e0;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
}

.yellow-view {
  margin-top: 10px;
  padding: 20px;
  background: #fff4db;
  border-radius: 8px;
  box-sizing: border-box;
  color: #a95300;
  margin-bottom: 16px;
  padding: 12px 14px 12px 24px;
}
.view-page{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding-bottom: 20px;
    width: 100%;
    .item-view{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
            height: 65px;
            width: 65px;
        }
    }
    .fenge{
        width: 29px; height: 17px; margin-bottom: 30px; padding: 0px 20px;  
    }
}
.text-one-line{
  flex-shrink: 0;
}
</style>